import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

import { cnmcQueryKeys } from './query-keys';

export type TDeleteCNMCFileParams = {
  cnmcId: string;
  fileId: string;
};

export async function deleteCNMCFile({
  cnmcId,
  fileId,
}: TDeleteCNMCFileParams): Promise<undefined> {
  return mediaManagerClient.delete(`/api/v1/cnmcs/${cnmcId}/files/${fileId}`);
}

type MutationFn = typeof deleteCNMCFile;

type TUseUploadFileToCNMCParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteCNMCFile({ config = {} }: TUseUploadFileToCNMCParams = {}) {
  return useMutation({
    ...config,
    mutationFn: deleteCNMCFile,
    onError(error) {
      console.error(error);
    },
    onSuccess(data, variables, context) {
      queryClient.invalidateQueries({ queryKey: cnmcQueryKeys.all });
      config.onSuccess?.(data, variables, context);
    },
  });
}
